import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import * as R from "ramda";

import {
  getDueNext7Days,
  getPastDue,
  getDueToday,
  getCountOfAllCompletedTasks,
  getCountOfAllTasks
} from "../selectors";
import { Div, Span } from "components/Base";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import { getters, actions } from "Portal/PortalHome/model";

const decorate = R.compose(
  withRouter,
  connect(
    state => ({
      dueNext7Days: getDueNext7Days(state),
      pastDue: getPastDue(state),
      dueToday: getDueToday(state),
      getCountOfAllTasks: getCountOfAllTasks(state),
      getCountOfAllCompletedTasks: getCountOfAllCompletedTasks(state),
      filters: getters.filters(state),
      percent_complete: getters.percent_complete(state)
    }),
    {
      toggleDueDate: actions.toggleDueDate,
      toggleDueDateReverse: actions.toggleDueDateReverse
    }
  ),
  CSSModules(css)
);

const Notifications = ({
  dueNext7Days,
  pastDue,
  dueToday,
  scrollToTasks,
  toggleDueDate,
  getCountOfAllCompletedTasks,
  getCountOfAllTasks
}) => {
  return (
    <>
      {getCountOfAllCompletedTasks === getCountOfAllTasks &&
        getCountOfAllTasks > 0 && (
          <Div
            display="column"
            bg="white"
            px={3}
            py={3}
            bra={3}
            mb={3}
            shadow={{
              default: 0,
              hover: 2
            }}
            style={{
              cursor: "pointer"
            }}
          >
            <Div
              width={1}
              fs={3}
              mt={1}
              color="#757575"
              display="row"
              style={{
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
              }}
            >
              <span
                className="material-icons"
                style={{ color: "rgb(55, 178, 77)", maxWidth: "30px" }}
              >
                task_alt
              </span>
              <Div fs={4} fw={3} ml={2} color="black">
                Good work! You don’t have any incomplete tasks due soon.
              </Div>
              <Div
                display="row.flex-end.center"
                flex={1}
                onClick={() => {
                  toggleDueDate();
                  scrollToTasks();
                }}
              >
                <Span fw={1} fs={1} color="primary7">
                  See tasks
                </Span>
              </Div>
            </Div>
          </Div>
        )}
      {dueToday > 0 && getCountOfAllCompletedTasks !== getCountOfAllTasks && (
        <Div
          display="column"
          bg="white"
          px={3}
          py={3}
          bra={3}
          mb={3}
          shadow={{
            default: 0,
            hover: 2
          }}
          style={{
            cursor: "pointer"
          }}
        >
          <Div
            width={1}
            fs={3}
            mt={1}
            color="#757575"
            display="row"
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word"
            }}
          >
            <span
              className="material-icons"
              style={{ color: "rgb(245, 159, 0)", maxWidth: "30px" }}
            >
              warning_triangle_exclamation
            </span>
            <Div fs={4} fw={3} color="black">
              {dueToday} task(s) due today
            </Div>
            <Div
              display="row.flex-end.center"
              flex={1}
              onClick={() => {
                toggleDueDate();
                scrollToTasks();
              }}
            >
              <Span fw={1} fs={1} color="primary7">
                See tasks
              </Span>
            </Div>
          </Div>
        </Div>
      )}
      {dueNext7Days > 0 && getCountOfAllCompletedTasks !== getCountOfAllTasks && (
        <Div
          display="column"
          bg="white"
          px={3}
          py={3}
          bra={3}
          mb={3}
          shadow={{
            default: 0,
            hover: 2
          }}
          style={{
            cursor: "pointer"
          }}
        >
          <Div
            width={1}
            fs={3}
            mt={1}
            color="#757575"
            display="row"
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word"
            }}
          >
            <span
              className="material-icons"
              style={{ color: "grey", maxWidth: "30px" }}
            >
              info
            </span>
            <Div fs={4} fw={3} ml={1} color="black">
              {dueNext7Days} task(s) due this week
            </Div>
            <Div
              display="row.flex-end.center"
              flex={1}
              onClick={() => {
                toggleDueDate();
                scrollToTasks();
              }}
            >
              <Span fw={1} fs={1} color="primary7">
                See tasks
              </Span>
            </Div>
          </Div>
        </Div>
      )}
      {pastDue > 0 && getCountOfAllCompletedTasks !== getCountOfAllTasks && (
        <Div
          display="column"
          bg="white"
          px={3}
          py={3}
          bra={3}
          mb={3}
          shadow={{
            default: 0,
            hover: 2
          }}
          style={{
            cursor: "pointer"
          }}
        >
          <Div
            width={1}
            fs={3}
            mt={1}
            color="#757575"
            display="row"
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word"
            }}
          >
            <span
              className="material-icons"
              style={{ color: "red", maxWidth: "30px" }}
            >
              priority_high
            </span>
            <Div fs={4} fw={3} ml={1} color="black">
              {pastDue} task(s) overdue
            </Div>
            <Div
              display="row.flex-end.center"
              flex={1}
              onClick={() => {
                toggleDueDate();
                scrollToTasks();
              }}
            >
              <Span fw={1} fs={1} color="primary7">
                See tasks
              </Span>
            </Div>
          </Div>
        </Div>
      )}
    </>
  );
};

export default decorate(Notifications);
